"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.implementTypedPlatformFunction = void 0;
var implementTypedPlatformFunction_1 = require("./implementTypedPlatformFunction");
Object.defineProperty(exports, "implementTypedPlatformFunction", { enumerable: true, get: function () { return implementTypedPlatformFunction_1.implementTypedPlatformFunction; } });
